// extracted by mini-css-extract-plugin
export var technologies = "grid-module--technologies--RrdoZ";
export var react = "grid-module--react--qGdlG";
export var gatsby = "grid-module--gatsby--kiq+d";
export var html = "grid-module--html--uJL4V";
export var css = "grid-module--css--kFTOw";
export var js = "grid-module--js--v8AAR";
export var php = "grid-module--php--2SK+1";
export var laravel = "grid-module--laravel--vEKNx";
export var process = "grid-module--process--5scDr";
export var development = "grid-module--development--CXPAS";
export var ui = "grid-module--ui--45NGq";
export var prototype = "grid-module--prototype--rk-ZN";
export var others = "grid-module--others--rmhGj";
export var ml = "grid-module--ml--8lTOv";
export var c = "grid-module--c--qy+pP";
export var java = "grid-module--java--v9T4I";